module.exports = __webpack_public_path__ + "img/TNB.6ab4de4e.svg";